import { render } from "./allow-public-sharing.vue?vue&type=template&id=6549bbfb&lang=pug"
import script from "./allow-public-sharing.vue?vue&type=script&lang=js"
export * from "./allow-public-sharing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__